import { Router, RoutesRecognized } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { StoreService } from '../store.service';
import { DataService } from '../data.service';
import { UtilitiesService } from '../core/utilities.service';

const DEFAULT_DURATION = 250;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out')),
    ]),
  ],
})
export class NavbarComponent implements OnInit {
  isMobile: boolean = false;
  isSectionCta: boolean = false;
  width = window.innerWidth;
  mobileWidth = 600;
  canInDashboard = false;

  visible: boolean = false;

  dealer: any = [];
  defaultStore;
  bearer;
  store_id;
  defaultData;
  partnerPlatformUrl;

  constructor(
    private router: Router,
    private svc: StoreService,
    private dataService: DataService,
    public utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        let route = event.state.root.firstChild;
        this.visible = route?.data.navbar;
      }
    });
  }

  onWindowResize(event: any) {
    this.width = event.target.innerWidth;
    this.isSectionCta = this.width < this.mobileWidth;
  }

  toggleNav() {
    this.isMobile = !this.isMobile;
  }

  goToSignUp() {
    window.location.href = '/create-store';
  }
}
